import React, { useState } from 'react';
import Input from './Input';
import {
  EyeIcon,
  HiddenEyeIcon,
  XRedCircleIcon,
  XCircleIcon,
  CheckCircleIcon,
} from '../components/icons';
import {
  PasswordConditions,
  InputMobile,
  InputDesktop,
} from '../pages/Authentication/styles';

interface Props {
  isError?: boolean;
  labelText?: string;
  isBottomText?: boolean;
  bottomText?: string;
  value: string;
  passwordConditions?: boolean;
  onChange: (e: any) => void;
  onBlur?: (e?:any) => void;
  isColor?: boolean;
}
const PasswordInput = (props: Props) => {
  const [isHidden, setIsHidden] = useState(false);
  const [specialError, setSpecialError] = useState(false);
  const [minimumError, setMinimumError] = useState(false);
  const [noMinimumError, setNoMinimumError] = useState(false);
  const [noSpecialError, setNoSpecialError] = useState(false);
  let regex = /[^a-zA-Z0-9]/g;
  
  const handleChange = (e: any) => {
    props.onChange(e.target.value);

    if (props.passwordConditions) {
      setNoMinimumError((e.target.value || '').length >= 8);
      setNoSpecialError(regex.test(e.target.value));
      if (minimumError && (e.target.value || '').length >= 8) {
        setMinimumError(false);
      }
      if (specialError && regex.test(e.target.value)) {
        setSpecialError(false);
      }
    }
  };
  const handleBlur = (e: any) => {
    if (props.onBlur) props.onBlur(e);
    if (props.passwordConditions) {
      setMinimumError((e.target.value || '').length < 8);
      setSpecialError(!regex.test(e.target.value));
    }
  };
  return (
    <>
      <InputMobile>
        <Input
          inputType={props.isError || props.isColor ? 'InputError' : 'InputBase'}
          width='318px'
          icon={
            isHidden ? (
              <HiddenEyeIcon
                onClick={() => setIsHidden(!isHidden)}
                style={{ cursor: 'pointer' }}
              />
            ) : (
              <EyeIcon
                onClick={() => setIsHidden(!isHidden)}
                style={{ cursor: 'pointer' }}
              />
            )
          }
          type={isHidden ? 'text' : 'password'}
          placeholder={props.labelText}
          onChange={handleChange}
          onBlur={handleBlur}
          value={props.value}
          bottomText={props.bottomText}
          isBottomText={props.isBottomText}
          isColor={props.isColor}
        />
      </InputMobile>
      <InputDesktop>
        <Input
          inputType={props.isError || props.isColor ? 'InputError' : 'InputBase'}
          width='416px'
          icon={
            isHidden ? (
              <HiddenEyeIcon
                onClick={() => setIsHidden(!isHidden)}
                style={{ cursor: 'pointer' }}
              />
            ) : (
              <EyeIcon
                onClick={() => setIsHidden(!isHidden)}
                style={{ cursor: 'pointer' }}
              />
            )
          }
          type={isHidden ? 'text' : 'password'}
          isLabel
          labelText={props.labelText}
          onChange={handleChange}
          onBlur={handleBlur}
          value={props.value}
          bottomText={props.bottomText}
          isBottomText={props.isBottomText}
          isColor={props.isColor}
        />
      </InputDesktop>
      {props.passwordConditions && (
        <PasswordConditions>
          <div style={{ color: '#444340' }}>Make sure your password has:</div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              marginTop: 8,
            }}
          >
            {noMinimumError ? (
              <CheckCircleIcon />
            ) : minimumError ? (
              <XRedCircleIcon />
            ) : (
              <XCircleIcon />
            )}
            <div
              style={
                noMinimumError
                  ? { color: 'rgba(18, 85, 24, 0.76)', marginLeft: 8 }
                  : minimumError
                  ? { color: '#C50E29', marginLeft: 8 }
                  : { color: '#93918F', marginLeft: 8 }
              }
            >
              Minimum of 8 characters
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              marginTop: 8,
            }}
          >
            {noSpecialError ? (
              <CheckCircleIcon />
            ) : specialError ? (
              <XRedCircleIcon />
            ) : (
              <XCircleIcon />
            )}
            <div
              style={
                noSpecialError
                  ? { color: 'rgba(18, 85, 24, 0.76)', marginLeft: 8 }
                  : specialError
                  ? { color: '#C50E29', marginLeft: 8 }
                  : { color: '#93918F', marginLeft: 8 }
              }
            >
              At least one special character
            </div>
          </div>
        </PasswordConditions>
      )}
    </>
  );
};

export default PasswordInput;
